Vue.component('MessageTemplatesIndexComponent', require('./components/MessageTemplatesIndexComponent').default);
Vue.component('MessageTemplatesGetComponent', require('./components/MessageTemplatesFormComponent').default);
